import review1 from 'assets/images/Shawn-bf42c7b909dae3111d18a21870ee6ca5.png';
import review2 from 'assets/images/Sarah-45de0e53b7b2520ebbac35c454b9748a.png';
import review3 from 'assets/images/Emma-5a662db9bcf55809a1fefb2ea17634bc.png';

const reviewInfos = [
	{
		img: review1,
		name: 'Shawn Wang ',
		nameDesc: 'in Singapore',
		job: 'Software Engineer',
		jobDesc: ' at Amazon',
		desc: '"It\'s scary to change careers. I only gained confidence that I could code by working through the hundreds of hours of free lessons on freeCodeCamp. Within a year I had a six-figure job as a Software Engineer. freeCodeCamp changed my life."',
	},

	{
		img: review2,
		name: 'Sarah Chima ',
		nameDesc: 'in Nigeria',
		job: 'Software Engineer',
		jobDesc: ' at ChatDesk',
		desc: 'freeCodeCamp was the gateway to my career as a software developer. The well-structured curriculum took my coding knowledge from a total beginner level to a very confident level. It was everything I needed to land my first dev job at an amazing company.',
	},

	{
		img: review3,
		name: 'Emma Bostian ',
		nameDesc: 'in Sweden',
		job: 'Software Engineer',
		jobDesc: ' at Spotify',
		desc: "I've always struggled with learning JavaScript. I've taken many courses but freeCodeCamp's course was the one which stuck. Studying JavaScript as well as data structures and algorithms on freeCodeCamp gave me the skills and confidence I needed to land my dream job as a software engineer at Spotify.",
	},
];

export { reviewInfos };
